export const categories = [
  {
    id: "dianshang-youhui",
    name: "电商优惠",
    icon: "ri-shopping-bag-3-line",
    description: "各大电商平台优惠券、满减活动、限时折扣汇总",
    color: "accent",
    resourceCount: 128,
  },
  {
    id: "huiyuan-quanyi",
    name: "会员权益",
    icon: "ri-vip-crown-line",
    description: "视频、音乐、阅读等平台会员免费领取与折扣",
    color: "primary",
    resourceCount: 96,
  },
  {
    id: "shenghuo-butie",
    name: "生活补贴",
    icon: "ri-hand-heart-line",
    description: "房租补贴、餐饮优惠、交通补贴等日常生活福利",
    color: "secondary",
    resourceCount: 85,
  },
  {
    id: "zhengfu-fuli",
    name: "政府福利",
    icon: "ri-government-line",
    description: "社保、公积金、个税减免、创业补贴等政策福利",
    color: "accent",
    resourceCount: 64,
  },
  {
    id: "jinrong-fuwu",
    name: "金融服务",
    icon: "ri-bank-line",
    description: "信用卡权益、贷款优惠、理财产品推荐等金融福利",
    color: "primary",
    resourceCount: 72,
  },
  {
    id: "jiaoyu-fuli",
    name: "教育福利",
    icon: "ri-book-open-line",
    description: "免费课程、培训补贴、学历提升、考试资料等教育资源",
    color: "secondary",
    resourceCount: 58,
  },
  {
    id: "jiankang-yiliao",
    name: "健康医疗",
    icon: "ri-heart-pulse-line",
    description: "免费体检、疫苗接种、医保政策、健康管理服务",
    color: "accent",
    resourceCount: 47,
  },
  {
    id: "chuxing-jiaotong",
    name: "出行交通",
    icon: "ri-car-line",
    description: "打车优惠、机票折扣、火车票福利、共享单车月卡",
    color: "primary",
    resourceCount: 53,
  },
];

export const articles = [
  {
    id: "article-1",
    title: "2024年各大电商平台双十一优惠攻略大全",
    excerpt: "一年一度的双十一购物节即将到来，各大电商平台纷纷推出重磅优惠活动。本文为您整理了淘宝、京东、拼多多等主流平台的省钱攻略...",
    content: `<p>一年一度的双十一购物节即将到来，各大电商平台纷纷推出重磅优惠活动。对于精明的消费者来说，提前了解各平台的优惠规则，合理规划购物清单，能够最大化地享受折扣。</p>
<h2>淘宝/天猫双十一攻略</h2>
<p>淘宝今年的双十一活动从10月24日开始预售，跨店满减力度为每满300减50。此外，88VIP会员还可享受额外9.5折优惠，叠加品牌优惠券使用效果更佳。</p>
<h2>京东双十一攻略</h2>
<p>京东双十一主打"百亿补贴"，PLUS会员专享价覆盖了数码、家电、日用品等全品类。特别推荐关注京东自营商品的价保服务，买贵了可以申请退差价。</p>
<h2>拼多多双十一攻略</h2>
<p>拼多多延续"天天双十一"策略，百亿补贴频道持续加码。建议关注每日限时秒杀和品牌黑卡活动，部分商品价格低至五折。</p>
<p>总结来说，建议消费者提前列好购物清单，对比各平台价格，善用会员权益和优惠券叠加，才能买到最划算的商品。</p>`,
    category: "dianshang-youhui",
    categoryName: "电商优惠",
    image: "https://readdy.ai/api/search-image?query=Online%20shopping%20festival%20concept%20with%20shopping%20bags%20and%20discount%20tags%20on%20warm%20cream%20background%2C%20festive%20atmosphere%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting%2C%20e-commerce%20theme&width=800&height=450&seq=article-1-hero&orientation=landscape",
    date: "2024-10-15",
    readTime: "8分钟",
    tags: ["双十一", "电商", "优惠攻略", "省钱"],
  },
  {
    id: "article-2",
    title: "视频会员免费领取方法汇总：优酷、爱奇艺、腾讯视频",
    excerpt: "想知道如何免费获取各大视频平台会员吗？本文整理了优酷、爱奇艺、腾讯视频等主流平台的会员免费领取方法，让你追剧不花钱...",
    content: `<p>随着视频平台会员价格不断上涨，越来越多的用户开始寻找免费获取会员的方法。本文将为您详细介绍各大视频平台会员的免费获取途径。</p>
<h2>优酷会员免费领取</h2>
<p>优酷会员可以通过支付宝会员积分兑换，88VIP用户自动获得优酷会员权益。此外，中国移动、中国联通等运营商的积分商城也经常有优酷会员兑换活动。</p>
<h2>爱奇艺会员免费获取</h2>
<p>爱奇艺经常与银行合作推出信用卡权益，如招商银行、中信银行等信用卡用户可享受月度会员权益。京东PLUS会员也包含爱奇艺会员权益。</p>
<h2>腾讯视频会员免费领取</h2>
<p>腾讯视频会员可通过腾讯王卡套餐免费获得，QQ超级会员也包含腾讯视频VIP权益。另外，微信支付积分商城经常有兑换活动。</p>
<p>建议大家多渠道关注，合理利用各类会员权益的互通机制，最大程度降低追剧成本。</p>`,
    category: "huiyuan-quanyi",
    categoryName: "会员权益",
    image: "https://readdy.ai/api/search-image?query=Video%20streaming%20concept%20with%20media%20player%20interface%20on%20warm%20cream%20background%2C%20entertainment%20theme%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20soft%20lighting&width=800&height=450&seq=article-2-hero&orientation=landscape",
    date: "2024-10-12",
    readTime: "6分钟",
    tags: ["视频会员", "免费领取", "会员权益", "追剧"],
  },
  {
    id: "article-3",
    title: "2024年各城市租房补贴政策大盘点",
    excerpt: "北上广深等一线城市以及新一线城市纷纷推出租房补贴政策，符合条件的年轻人和人才可享受每月数百至数千元的租房补贴...",
    content: `<p>随着各城市人才争夺战不断升级，租房补贴已成为吸引人才的重要政策工具。本文整理了2024年主要城市的租房补贴政策，帮助您了解自己是否符合申请条件。</p>
<h2>北京市租房补贴</h2>
<p>北京市针对新就业大学生和引进人才提供租房补贴，补贴标准根据区域有所不同。核心城区每月最高补贴可达2000元，申请人需要通过单位统一申报。</p>
<h2>上海市租房补贴</h2>
<p>上海的租房补贴主要面向重点产业人才和应届毕业生。浦东新区、临港新片区等重点区域补贴力度更大，最高可达每月3000元。</p>
<h2>深圳市租房补贴</h2>
<p>深圳的人才租房补贴力度在全国领先，市级补贴叠加区级补贴后，部分人才每月可获得4000元以上的租房支持。</p>
<p>申请租房补贴一般需要满足年龄、学历、社保缴纳等条件，建议关注当地人社局官网获取最新政策信息。</p>`,
    category: "shenghuo-butie",
    categoryName: "生活补贴",
    image: "https://readdy.ai/api/search-image?query=Modern%20apartment%20rental%20concept%20with%20keys%20and%20documents%20on%20warm%20cream%20background%2C%20housing%20subsidy%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-3-hero&orientation=landscape",
    date: "2024-10-10",
    readTime: "7分钟",
    tags: ["租房补贴", "政策福利", "人才引进", "住房"],
  },
  {
    id: "article-4",
    title: "个税专项附加扣除全攻略：你能省多少钱？",
    excerpt: "2024年个税专项附加扣除标准进一步提高，包括子女教育、继续教育、大病医疗、住房贷款利息、住房租金、赡养老人、3岁以下婴幼儿照护等七大项...",
    content: `<p>个人所得税专项附加扣除是国家为减轻纳税人负担推出的重要政策。了解并正确填报各项扣除，每年可以为您节省数百甚至数千元的个税支出。</p>
<h2>子女教育扣除</h2>
<p>每个子女每月可扣除2000元，从学前教育到博士研究生阶段均可享受。夫妻双方可选择一方100%扣除或双方各50%扣除。</p>
<h2>住房贷款利息扣除</h2>
<p>首套住房贷款利息每月可扣除1000元，扣除期限最长不超过240个月。需要注意的是，住房贷款利息和住房租金只能择一扣除。</p>
<h2>赡养老人扣除</h2>
<p>赡养60岁以上父母的，独生子女每月可扣除3000元，非独生子女与兄弟姐妹分摊每月3000元的扣除额度。</p>
<h2>3岁以下婴幼儿照护扣除</h2>
<p>每个3岁以下婴幼儿每月可扣除2000元，可选择由父母一方全额扣除或双方各扣除50%。</p>
<p>建议每年年初通过个人所得税APP确认扣除信息，确保及时享受政策红利。</p>`,
    category: "zhengfu-fuli",
    categoryName: "政府福利",
    image: "https://readdy.ai/api/search-image?query=Tax%20calculation%20concept%20with%20calculator%20and%20documents%20on%20warm%20cream%20background%2C%20financial%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-4-hero&orientation=landscape",
    date: "2024-10-08",
    readTime: "10分钟",
    tags: ["个税", "专项扣除", "省钱", "税务"],
  },
  {
    id: "article-5",
    title: "信用卡权益大比拼：哪张卡最值得办？",
    excerpt: "各大银行信用卡权益对比，包括机场贵宾厅、免费体检、道路救援、购物返现等。帮你选出最适合自己消费习惯的信用卡...",
    content: `<p>随着信用卡市场竞争日趋激烈，各大银行不断升级信用卡权益以吸引用户。本文从多个维度对比主流信用卡的权益差异，帮助您选择最适合的信用卡。</p>
<h2>出行权益对比</h2>
<p>机场贵宾厅方面，招商银行经典白金卡提供无限次龙腾出行权益，浦发AE白提供PP卡无限次使用，中信i白金提供每年6次龙腾权益。</p>
<h2>生活权益对比</h2>
<p>免费体检方面，广发鼎极卡提供每年一次三甲医院体检套餐，民生精英白提供齿科护理权益。道路救援方面，多数白金卡提供全年无限次免费道路救援。</p>
<h2>购物返现对比</h2>
<p>日常消费返现方面，招商银行Young卡餐饮消费5%返现，交通银行沃尔玛卡店内消费最高2.5%返利，建设银行龙卡境外消费返现比例最高可达8%。</p>
<p>建议根据自身消费结构选择2-3张信用卡组合使用，最大化权益覆盖。</p>`,
    category: "jinrong-fuwu",
    categoryName: "金融服务",
    image: "https://readdy.ai/api/search-image?query=Credit%20card%20comparison%20concept%20with%20multiple%20cards%20on%20warm%20cream%20background%2C%20financial%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-5-hero&orientation=landscape",
    date: "2024-10-05",
    readTime: "9分钟",
    tags: ["信用卡", "权益对比", "返现", "出行"],
  },
  {
    id: "article-6",
    title: "免费在线课程平台推荐：从编程到摄影全覆盖",
    excerpt: "整理了国内外优质免费在线学习平台，包括中国大学MOOC、学堂在线、B站学习区等，涵盖编程开发、设计创作、语言学习等多个领域...",
    content: `<p>在互联网时代，获取优质学习资源从未如此便捷。本文整理了国内外最值得推荐的免费在线学习平台，帮助您实现零成本自我提升。</p>
<h2>国内平台推荐</h2>
<p><strong>中国大学MOOC</strong>：汇聚清华、北大等顶尖高校的优质课程，涵盖计算机、经济、文学等几乎所有学科。完成课程后可获得证书。</p>
<p><strong>学堂在线</strong>：由清华大学发起，课程质量高，特别推荐计算机和人工智能相关课程。</p>
<p><strong>B站学习区</strong>：内容涵盖编程、设计、摄影、语言等，以视频教程为主，学习氛围轻松。</p>
<h2>国际平台推荐</h2>
<p><strong>Coursera</strong>：虽然部分课程收费，但可申请奖学金免费学习。与斯坦福、耶鲁等世界名校合作。</p>
<p>建议根据自己的学习目标选择合适的平台，制定系统的学习计划，坚持每天学习，日积月累必有收获。</p>`,
    category: "jiaoyu-fuli",
    categoryName: "教育福利",
    image: "https://readdy.ai/api/search-image?query=Online%20learning%20platform%20concept%20with%20laptop%20and%20books%20on%20warm%20cream%20background%2C%20education%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-6-hero&orientation=landscape",
    date: "2024-10-03",
    readTime: "7分钟",
    tags: ["免费课程", "在线学习", "MOOC", "自我提升"],
  },
  {
    id: "article-7",
    title: "全国免费体检政策指南：这些检查不用花钱",
    excerpt: "国家基本公共卫生服务项目为不同年龄段人群提供免费体检服务，包括儿童、孕产妇、老年人和慢性病患者等，了解你的免费体检权益...",
    content: `<p>国家基本公共卫生服务项目为居民提供了多项免费健康检查服务，但很多人并不清楚自己可以享受哪些免费体检。本文将详细介绍各类人群的免费体检权益。</p>
<h2>老年人免费体检</h2>
<p>65岁及以上老年人每年可享受一次免费健康体检，包括血常规、尿常规、肝功能、肾功能、血糖、血脂、心电图和腹部B超等项目。可在居住地社区卫生服务中心预约。</p>
<h2>孕产妇免费检查</h2>
<p>孕产妇可享受5次免费产前检查，包括血常规、尿常规、血型、肝功能、肾功能、乙肝等检查。产后还可享受免费访视服务。</p>
<h2>儿童免费体检</h2>
<p>0-6岁儿童可享受免费健康管理服务，包括新生儿访视、婴幼儿健康检查和学龄前儿童健康检查，覆盖生长发育评估、听力筛查等项目。</p>
<p>建议关注当地社区卫生服务中心的通知，主动了解并享受这些免费健康服务。</p>`,
    category: "jiankang-yiliao",
    categoryName: "健康医疗",
    image: "https://readdy.ai/api/search-image?query=Health%20checkup%20concept%20with%20stethoscope%20and%20medical%20documents%20on%20warm%20cream%20background%2C%20healthcare%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-7-hero&orientation=landscape",
    date: "2024-09-28",
    readTime: "6分钟",
    tags: ["免费体检", "健康服务", "公共卫生", "医疗福利"],
  },
  {
    id: "article-8",
    title: "打车出行优惠合集：滴滴、高德、美团打车谁最便宜？",
    excerpt: "对比主流打车平台的优惠策略和会员权益，包括滴滴出行、高德打车、美团打车、T3出行等，教你如何花最少的钱出行...",
    content: `<p>随着出行平台竞争加剧，各家纷纷推出优惠活动吸引用户。本文对比主流打车平台的优惠策略，帮助您找到最省钱的出行方式。</p>
<h2>滴滴出行优惠策略</h2>
<p>滴滴会员体系分为白银、黄金、铂金、钻石四个等级，高级会员可享受优先派单和专属优惠。新用户首单通常有较大折扣，老用户可通过签到和任务获取优惠券。</p>
<h2>高德打车优惠策略</h2>
<p>高德打车聚合了多个出行平台，可通过比价功能选择最便宜的方案。经常有满减活动和限时优惠券，支付宝积分也可兑换高德打车券。</p>
<h2>美团打车优惠策略</h2>
<p>美团打车常与新用户优惠和外卖会员权益联动。美团会员可享受专属打车折扣，在美团外卖消费后常赠送打车券。</p>
<p>建议同时安装多个打车App，出行前进行比价，优先选择有优惠活动的平台，积少成多能省下不少出行费用。</p>`,
    category: "chuxing-jiaotong",
    categoryName: "出行交通",
    image: "https://readdy.ai/api/search-image?query=Ride%20hailing%20concept%20with%20car%20and%20smartphone%20on%20warm%20cream%20background%2C%20transportation%20theme%2C%20clean%20composition%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=450&seq=article-8-hero&orientation=landscape",
    date: "2024-09-25",
    readTime: "5分钟",
    tags: ["打车优惠", "出行", "比价", "省钱"],
  },
];

export const popularArticles = [
  articles[0], articles[1], articles[2], articles[3], articles[4], articles[5],
];

export const getArticlesByCategory = (categoryId: string) => {
  return articles.filter((a) => a.category === categoryId);
};

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id) || null;
};

export const getCategoryById = (id: string) => {
  return categories.find((c) => c.id === id) || null;
};